import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect, useState } from 'react';
import shallow from 'zustand/shallow';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { FiMap } from 'react-icons/fi';
import { FaQuestion } from 'react-icons/fa';
import { GiJourney } from 'react-icons/gi';
import useStore from './../store';
import { CoreButton } from './../../../core';
import PanelFilterView from './../PanelFilterView/PanelFilterView';
import PanelLayersView from './../PanelLayersView/PanelLayersView';
import PanelInfoView from './../PanelInfoView/PanelInfoView';

var PanelModal = function PanelModal(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]); // Generic store value setter.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  }); // Track and update intro modal display

  var showPanelModal = useStore(function (state) {
    return state.showPanelModal;
  }); // Toggle panel modal display state.

  var togglePanelModal = function togglePanelModal() {
    setStoreValues({
      showPanelModal: !showPanelModal
    });
  };

  var slideoutPanel = useStore(function (state) {
    return state.slideoutPanel;
  });
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: showPanelModal,
    toggle: togglePanelModal,
    className: clsx('panel-modal', slideoutPanel.panel.length > 0 ? 'panel-view-' + slideoutPanel.panel : 'panel-view-none'),
    backdrop: true,
    keyboard: true,
    autoFocus: true,
    centered: true,
    height: '65vh',
    width: '90%'
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: togglePanelModal
  }), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(PanelFilterView, null), /*#__PURE__*/React.createElement(PanelLayersView, null), /*#__PURE__*/React.createElement(PanelInfoView, null)));
};

export default PanelModal;